import { getRelativeURL } from "./commonHelpers";

export const Page_Proposal = getRelativeURL(
    `/ui/production/proposal`
  );
export const Page_Orders_Landing = "/ui/production/orderentry"
export const Page_PA_Orders_Landing = "/ui/production/paorderentry"
  export const Page_ChangeOrder = getRelativeURL(
    `/ui/production/ChangeOrder`
  );
export const Page_ProposalLineItemTemplate=getRelativeURL('/ui/production/proposal/templatelineitem')
export const Page_Payment_Plan = getRelativeURL(
    `/intranet/Members/production/paymentplan.aspx`
  );
export const Page_Template_Preview = getRelativeURL(`/ui/template/preview`);
export const Page_Proposal_Renew=getRelativeURL(`/ui/proposalrenew`)
export const Page_TemplateDetails = getRelativeURL(`/ui/templateDetails`);

export const PAGE_JOB_VIEW = getRelativeURL(`/ui/AR/JobView?JobID=`);

export const Page_Business_Units  ='/ui/Admin/BusinessUnit';
export const Page_Products = '/ui/Admin/Product';
export const Page_Rate_Cards = '/ui/Admin/RateCardAllocations';